<template>
  <div class="home">
    <div class="login">
      <div class="flex">
        <div class="loginBg"></div>
        <div class="loginBox">
          <h1>
            <router-link to="/">
              <img src="@/assets/images/logo.png" alt="" />
            </router-link>
          </h1>
          <div class="form">
            <p>이메일(아이디)</p>
            <input type="text" v-model="email" />
            <p>비밀번호</p>
            <div class="password">
              <input type="password" v-model="password" @keyup.enter="submit" />
            </div>
            <AdminButton class="point large" @click="submit"
              >로그인</AdminButton
            >
            <div v-if="error" class="error">
              {{ errorMessage }}
            </div>
            <div class="forgot-password">
              <router-link to="/forgot-password"
                >비밀번호를 모르시나요?</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="copy">Copyright&copy; HIDIA All Rights Reserved.</p>
  </div>
</template>
<script>
import { login } from "@/api/index";
export default {
  data() {
    return {
      email: "",
      password: "",
      error: false,
      errorMessage: "",
    };
  },
  methods: {
    submit() {
      if (!this.email) {
        return this.$alert("이메일을 입력해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
      }
      if (!this.password) {
        return this.$alert("비밀번호를 입력해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
      }
      login({ email: this.email, password: this.password }).then((res) => {
        if (res.data.status === 200) {
          this.$store.dispatch("LOGIN", res.data);
          document.location.href = "/dashboard";
        } else {
          this.error = true;
          this.errorMessage =
            res.data.message || "이메일과 비밀번호를 다시 확인해 주세요.";
        }
      });
    },
  },
};
</script>
